<!-- 3-dots options menu: Regenerate / Make crisp / Detailed response (same as chatbot) -->
  <div class="response-options-menu-inline dropdown" [class.open]="isOpen" *ngIf="showRegenerate">
  <button type="button"
          #dropdownToggle
          class="dropdown-toggle t-bottom t-no-arrow"
          [attr.aria-label]="'OPTIONS_TOOLTIP' | translate"
          [attr.aria-expanded]="isOpen"
          [attr.aria-haspopup]="true"
          [disabled]="disabled"
          (click)="toggleMenu($event)">
    <span class="dropdown-text">
      <img src="assets/icons/more-menu-icon-1.svg" alt="moreMenu" class="icon-default" />
    </span>
  </button>
  <ul class="dropdown-content dropdown-content-fixed" *ngIf="isOpen" [ngStyle]="dropdownStyle">
    <!-- Timestamp at the top of the menu (only for agents, not chatbot v2) -->
    <li *ngIf="timestamp && isAgent" class="timestamp-item">
      <span class="timestamp-text">{{ timestamp }}</span>
    </li>
    <li>
      <a href="javascript:void(0)" (click)="onAction('regenerate'); $event.preventDefault()" [class.disabled]="disabled">
        <img src="assets/icons/icon-regenerate.svg" alt="" width="16" height="16" />
        {{ 'HOTKEYS_REGENERATE_YOUR_RESPONSE' | translate }}
      </a>
    </li>
    <li>
      <a href="javascript:void(0)" (click)="onAction('crisp'); $event.preventDefault()" [class.disabled]="disabled">
        <img src="assets/icons/icon-short-response.svg" alt="" width="16" height="16" />
        {{ 'HOTKEYS_MAKE_THE_RESPONSE_CRISP' | translate }}
      </a>
    </li>
    <li>
      <a href="javascript:void(0)" (click)="onAction('detailed'); $event.preventDefault()" [class.disabled]="disabled">
        <img src="assets/icons/icon-detailed-response.svg" alt="" width="16" height="16" />
        {{ 'HOTKEYS_DETAILED_RESPONSE' | translate }}
      </a>
    </li>
  </ul>
</div>
